import { signedFetch } from './client';

export async function startReplay(storeName: string, startTime: string, endTime: string) {
  return signedFetch('POST', `/stores/${storeName}/replay`, { startTime, endTime });
}
